import * as React from "react";
import { UitkCarousel } from "uitk-react-carousel";
import { Viewport, ViewSmall, ViewLarge } from "bernie-view";
import { useLocalization } from "@shared-ui/localization-context";
import { Attraction } from "typings/microserviceModels/destination-attractions-flex-module";
import { AspectRatioEnum } from "stores/thumbor/ThumborStore";
import { AttractionCard } from "./AttractionCard";
import { inject } from "mobx-react";
import { AttractionSectionProps } from "components/flexComponents/DestinationAttractions/typings";

export const AttractionSection = inject("thumbor")((props: AttractionSectionProps) => {
  const {
    attractions,
    context,
    locationName,
    attractionsKeyHelper,
    carouselAnalytics,
    headingKey,
    isActivity,
    isCountry
  } = props;
  const { formatText } = useLocalization();
  const desktopAttractions = attractions.filter((poi, index) => (attractions.length >= 6 ? index < 6 : index < 3));

  return (
    <Viewport>
      <ViewSmall>
        <UitkCarousel
          headline={`${Boolean(locationName) && formatText(headingKey, locationName)}`}
          analytics={carouselAnalytics}
          carouselName={isActivity ? "Activities" : "Pois"}
          buttonText={{
            nextButton: formatText("carousel.item.next"),
            prevButton: formatText("carousel.item.prev")
          }}
          {...carouselProps}
        >
          {attractions.map((attraction, attractionIndex) => (
            <AttractionCard
              key={attractionsKeyHelper.next()}
              attraction={attraction}
              imageUrl={safelyResizeImage(attraction, props)}
              position={attractionIndex + 1}
              context={context}
              uitkCardClassNames="uitk-carousel-item uitk-flex-justify-content-flex-start uitk-flex-column"
              isCountry={isCountry}
              isActivity={isActivity}
              attractionsKeyHelper={attractionsKeyHelper}
            />
          ))}
        </UitkCarousel>
      </ViewSmall>
      <ViewLarge>
        <div className="all-b-margin-three">
          {Boolean(locationName) && (
            <h3 className="uitk-type-heading-600 all-b-margin-three">{formatText(headingKey, locationName)}</h3>
          )}
          <div className="uitk-grid all-cell-1-3 all-x-gutter-three">
            {desktopAttractions.map((attraction, attractionIndex) => (
              <div className="uitk-cell all-b-margin-three" key={attractionsKeyHelper.next()}>
                <AttractionCard
                  attraction={attraction}
                  imageUrl={safelyResizeImage(attraction, props)}
                  position={attractionIndex + 1}
                  context={context}
                  uitkCardClassNames="attraction-card-desktop"
                  isCountry={isCountry}
                  isActivity={isActivity}
                  attractionsKeyHelper={attractionsKeyHelper}
                />
              </div>
            ))}
          </div>
        </div>
      </ViewLarge>
    </Viewport>
  );
});

export const carouselProps = {
  itemsVisible: { lg: 1, md: 1, sm: 1 },
  pageBy: 1,
  peekWidth: 24
};

export const safelyResizeImage = (attraction: Attraction, props: AttractionSectionProps) => {
  const image: string = attraction.media?.mediaUrl;

  return image && props.thumbor
    ? props.thumbor.safelyGenerateThumborizedImageUrl(
        image,
        340,
        192,
        props.context,
        AspectRatioEnum.DEFAULT,
        true,
        100
      )
    : image;
};
